import { FilterOutlined } from '@ant-design/icons';
import { Badge, Button, Popover } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilterPopup from './FilterPopup';

const Filters = ({
  country,
  onFilterChange,
  onFilterClear,
  appliedFilters,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { t } = useTranslation();
  const noOfUniqueFilters = useMemo(() => {
    return new Set(appliedFilters?.map((filter) => filter?.type))?.size;
  }, [appliedFilters]);

  const renderFilterPopup = () => {
    return (
      <FilterPopup
        country={country}
        appliedFilters={appliedFilters}
        onFilterChange={onFilterChange}
        onFilterClear={onFilterClear}
      />
    );
  };

  return (
    <Popover
      onOpenChange={setIsPopoverOpen}
      content={renderFilterPopup}
      trigger="click"
      placement="bottom"
    >
      <Badge
        count={noOfUniqueFilters}
        size="middle"
        overflowCount={9}
        color="blue"
      >
        <Button
          color="primary"
          icon={<FilterOutlined />}
          className={
            isPopoverOpen || noOfUniqueFilters > 0 ? 'filter-active' : ''
          }
        >
          {t('common.filters.filters')}
        </Button>
      </Badge>
    </Popover>
  );
};

export default Filters;
